import { render, staticRenderFns } from "./ContactStep.vue?vue&type=template&id=bda86482&scoped=true&"
import script from "./ContactStep.vue?vue&type=script&lang=js&"
export * from "./ContactStep.vue?vue&type=script&lang=js&"
import style0 from "./ContactStep.vue?vue&type=style&index=0&id=bda86482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda86482",
  null
  
)

export default component.exports